// 谷歌分析配置 (请替换为真实的GA ID)
export function initGoogleAnalytics() {
  // 在部署时替换为真实的 Google Analytics ID
  const GA_ID = 'G-XXXXXXXXXX';
  
  if (typeof window !== 'undefined' && GA_ID !== 'G-XXXXXXXXXX') {
    // 加载 gtag
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);

    // 初始化 gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
  }
}

// 事件跟踪
export function trackEvent(eventName, parameters = {}) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
  
  // 也可以发送到其他分析平台
  console.log('Event tracked:', eventName, parameters);
}

// 页面视图跟踪
export function trackPageView(page) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-XXXXXXXXXX', {
      page_path: page
    });
  }
}

// 转化跟踪
export function trackConversion(action, value = null) {
  const conversionData = {
    event_category: 'conversion',
    event_label: action,
    value: value
  };
  
  trackEvent('conversion', conversionData);
}

// 用户交互跟踪
export function setupInteractionTracking() {
  if (typeof document === 'undefined') return;
  
  // 跟踪按钮点击
  document.addEventListener('click', (e) => {
    if (e.target.matches('.btn-primary, .btn-secondary')) {
      trackEvent('button_click', {
        button_text: e.target.textContent.trim(),
        button_type: e.target.className.includes('primary') ? 'primary' : 'secondary'
      });
    }
  });

  // 跟踪外链点击
  document.addEventListener('click', (e) => {
    if (e.target.matches('a[href^="http"]')) {
      trackEvent('external_link_click', {
        url: e.target.href,
        text: e.target.textContent.trim()
      });
    }
  });

  // 跟踪邮件链接点击
  document.addEventListener('click', (e) => {
    if (e.target.matches('a[href^="mailto:"]')) {
      trackEvent('email_click', {
        email: e.target.href.replace('mailto:', '')
      });
    }
  });
}

// 热力图和用户行为分析 (可选)
export function initHeatmapTracking() {
  if (typeof window === 'undefined') return;
  
  // 可以集成 Hotjar、Crazy Egg 等热力图工具
  // 这里提供基础的滚动深度跟踪
  
  let maxScroll = 0;
  const trackScrollDepth = () => {
    const scrolled = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
    
    if (scrolled > maxScroll) {
      maxScroll = scrolled;
      
      // 跟踪滚动里程碑
      if (scrolled >= 25 && maxScroll < 25) {
        trackEvent('scroll_depth', { depth: '25%' });
      } else if (scrolled >= 50 && maxScroll < 50) {
        trackEvent('scroll_depth', { depth: '50%' });
      } else if (scrolled >= 75 && maxScroll < 75) {
        trackEvent('scroll_depth', { depth: '75%' });
      } else if (scrolled >= 90 && maxScroll < 90) {
        trackEvent('scroll_depth', { depth: '90%' });
      }
    }
  };

  window.addEventListener('scroll', trackScrollDepth);
}

// 错误跟踪
export function setupErrorTracking() {
  if (typeof window === 'undefined') return;
  
  window.addEventListener('error', (e) => {
    trackEvent('javascript_error', {
      error_message: e.message,
      error_filename: e.filename,
      error_lineno: e.lineno
    });
  });

  // Promise 错误跟踪
  window.addEventListener('unhandledrejection', (e) => {
    trackEvent('promise_rejection', {
      error_message: e.reason.toString()
    });
  });
}